import { ASSETS } from "@/lib/site";

const REASONS = [
  { n: "01", t: "Experienced Educator", b: "Years in the building, not just on the stage." },
  { n: "02", t: "Behavioral Consultant", b: "Trained to read systems and rebuild patterns." },
  { n: "03", t: "Proven Relationship Builder", b: "Trust is the curriculum — everything else follows." },
  { n: "04", t: "Veteran Leader", b: "USAF service forged the discipline behind the work." },
  { n: "05", t: "Author & Mentor", b: "Frameworks tested with real students, real staff." },
  { n: "06", t: "Practical & Actionable", b: "You'll leave with a plan, not just inspiration." },
];

export default function WhyChoose() {
  return (
    <section className="relative bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="eyebrow text-gold">Why Schools Choose CDaught</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-3 font-bold tracking-tight leading-[1.05]">
            Engaging delivery.
            <span className="block italic font-medium">Durable results.</span>
          </h2>
          <img
            src={ASSETS.classroom}
            alt="CDaught engaging with students in a classroom"
            className="mt-8 w-full h-80 object-cover hidden lg:block"
          />
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-[hsl(var(--line))]">
            {REASONS.map((r, i) => (
              <div
                key={r.n}
                data-testid={`reason-${i}`}
                className="grid grid-cols-12 gap-4 py-6 border-b border-[hsl(var(--line))] items-baseline group hover:bg-mist/60 transition-colors px-2 -mx-2"
              >
                <div className="col-span-2 font-serif text-2xl text-gold font-bold">{r.n}</div>
                <div className="col-span-10 md:col-span-4 font-serif text-2xl md:text-3xl text-navy font-semibold leading-tight">
                  {r.t}
                </div>
                <div className="col-span-12 md:col-span-6 text-[14px] text-navy/65 leading-relaxed">
                  {r.b}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
